import React from 'react';
import { assetPath, getCookie, onSignout } from '../utils/web-helper';
import LogoImage from '~images/bytesize_db/logo-new.png';

export default function MainHeader({showLogoutLink, LoginText, isOneTapEnabled, disableClick, showClassCodeLogin=false, showIconLeft=false, isSmallHeaderMobileLandscape=false}) {
    const searchParams = window.location.search?.length ? window.location.search : `?${window.location.hash?.split("?").pop()}`;
    const queryParams = new URLSearchParams(searchParams);
    const newPtlFlow = queryParams.get("new_ptl_flow") && queryParams.get("student_id");

    const onLogoutClick = () => {
      localStorage.setItem('from_signout', 'true');
    };

    return (
        <div className={`main-header ${showIconLeft ? 'main-header-left' : ''}`}>
            <a href={newPtlFlow ? "javascript:void(0);" : "/"} className= {"header-logo " + (disableClick && disableClick.toString() == "true" ? 'disable-click' : '') }>
                <img alt="Splashmath logo" src={assetPath(LogoImage)} className={`sm-logo ${isSmallHeaderMobileLandscape ? 'sm-header-mobile-landscape' : ""}`}/>
            </a>
            {showLogoutLink && <a data-method="delete" href= "/signout" onClick = {isOneTapEnabled ? onSignout : onLogoutClick} className={`header-logout ${isOneTapEnabled ? "g_id_signout" : ""}`}>
                Logout
            </a>}
            {LoginText && <a data-method="delete" href= "/signin" className="header-logout">
                Login
            </a>}

            {showClassCodeLogin && <div className="login-section">
                <span className="login-text">Have an account or class code?</span> <a className="class-code-login-btn" href="/signin">Login</a>
            </div>}
        </div>
    )
}